module.exports = __webpack_public_path__ + "img/double-image-hero-lincoln.17d9d3de.png";